var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpandeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6308 2.31491L9.08024 8.9613C8.97276 9.06963 8.84508 9.15561 8.7042 9.21429C8.56333 9.27296 8.41201 9.30315 8.25941 9.30315C8.1068 9.30315 7.95575 9.27296 7.81488 9.21429C7.674 9.15561 7.54632 9.06963 7.43884 8.9613L0.870085 2.36715C0.70936 2.20568 0.600055 2.00027 0.555762 1.77678C0.511468 1.55331 0.534138 1.32173 0.621126 1.11116C0.708114 0.900588 0.855457 0.720421 1.04456 0.593354C1.23367 0.466288 1.45632 0.397995 1.68415 0.397032L14.8039 0.344754C15.0329 0.343182 15.2571 0.409678 15.4482 0.535769C15.6393 0.661861 15.7885 0.841862 15.8771 1.05296C15.9657 1.26406 15.9897 1.4967 15.9459 1.72138C15.902 1.94606 15.7923 2.15265 15.6308 2.31491Z",
    fill: "#1592D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandeIcon);
export default __webpack_public_path__ + "static/media/expandeIcon.de57065da1d734b0c1374ce7d5e6e130.svg";
export { ForwardRef as ReactComponent };